/** A notification or approval row of the hub and the wall's dropdown, and what opening it does. */
import type { HubItem } from "@/components/panels/search-modal/hub-types";
import type { useNotificationActions } from "./use-notification-actions";

export type NotificationActions = ReturnType<typeof useNotificationActions>;
export type NotificationItem = Extract<
  HubItem,
  { type: "notification" | "approval" }
>;

/**
 * Opens a notification or approval row's target. True when the list should
 * close: release notes stay, their "Got it" only marks them read.
 */
export function openNotificationItem(
  item: NotificationItem,
  actions: NotificationActions,
): boolean {
  if (item.type === "approval") {
    actions.openApproval(item.approval);
    return true;
  }
  return actions.openRow(item.row) && item.row.target?.type !== "release_notes";
}
